(ns manage.content-configuration-page.context-source.view
  (:require [common.modal.dialog :refer [deletion-confirmation]]
            [common.modal.view :refer [defmodal]]
            [common.ui.list :as ui.list]
            [manage.content-configuration-page.context-source.custom]
            [manage.content-configuration-page.context-source.dsp-signal]
            [manage.content-configuration-page.context-source.dynamic-feed]
            [manage.content-configuration-page.context-source.manual-split-testing]
            [manage.content-configuration-page.context-source.poi]
            [manage.content-configuration-page.context-source.products]
            [manage.content-configuration-page.context-source.schema
             :refer [default-icon]]
            [manage.content-configuration-page.context-source.shared
             :refer [entity-view-cfg pull-pattern-context-source]]
            [manage.content-configuration-page.view.list :as lv]
            [re-frame.core :as rf]
            [uix.core :refer [$]]))

(defn list-cfg [cc]
  (lv/as-entity
   {:entity/ref cc
    :entity/icon default-icon
    :entity/label "Dynamic data"
    :entity/on-activate [[:manage.content-configuration-page.context-source.db/load-param-schemas]]
    :validation/schema :content-configuration
    :validation/pull-pattern [{:content-configuration/context-source pull-pattern-context-source}]
    :list/add-item-cfg
    {:add-item/label "Add context source"
     :add-item/select-options [:manage.content-configuration-page.context-source.schema/schema-options-filtered-by-adset-type]
     :add-item/add-fn
     (fn [schema-id]
       (rf/dispatch [:manage.content-configuration-page.context-source.db/create
                     schema-id]))}
    :list/items :content-configuration/context-source
    :list/->item-cfg entity-view-cfg
    :list/delete-item-event :manage.content-configuration-page.context-source.db/delete
    :list/empty-msg ($ ui.list/empty-msg {:title "Define your context sources"}
                       ($ :p
                          "To use dynamic data in your configuration, one or
                           multiple context sources can be added to an adset.")
                       ($ :p
                          "Once the context sources are added, you can use them as a
                           trigger in your rules or directly be leveraging the value
                           in the content.")
                       ($ :p
                          "Most context sources only need to be added in order to
                           make use of them, while some require additional
                           configuration."))}))

(defmodal confirm-delete ::confirm-delete
  [{:keys [rule-names feed-context-source-aliases placeholders+names cs]}]
  [deletion-confirmation
   {:on-submit #(rf/dispatch [:ui.store/delete cs])
    :entity-name "context source"
    :title "This context source is still in use"
    :submit-button-label (if placeholders+names
                           "Update targeting keys and delete context source"
                           "Update rules and delete context source")}
   (when (and rule-names (not placeholders+names))
     [:<>
      [:p "The following rules are using this context source, either as trigger
           or in a placeholder assignment:"]
      [:ul (for [r rule-names]
             ^{:key r} [:li r])]])
   (when feed-context-source-aliases
     [:<>
      [:p "The following feed context sources are using this context source in a lookup macro:"]
      [:ul (for [a feed-context-source-aliases]
             ^{:key a} [:li a])]])
   (when placeholders+names
     [:<>
      [:p "The following targeting keys are using this context source in their mappings:"]
      [:ul (for [[p name] placeholders+names]
             ^{:key p} [:li name])]])
   (cond
     (and rule-names (not feed-context-source-aliases))
     [:p "You can choose to continue anyway, automatically deleting related
     triggers and macros, or to cancel now and first update these rules
     manually."]

     (and feed-context-source-aliases (not rule-names))
     [:p "You can choose to continue anyway, automatically deleting feed lookup
     configurations, or to cancel now and first update these feed context
     sources manually."]

     placeholders+names
     [:p "You can choose to continue anyway, automatically deleting the context source
     and mappings from these targeting keys, or to cancel now and first update
     these targeting keys manually."]

     :else
     [:p "You can choose to continue anyway, automatically updating these rules
     and feed context sources, or to cancel now and first update these
     manually."])])
